import React, { useEffect, useState } from "react";
import axios from 'axios';
import { FaTrash } from "react-icons/fa";

export default function SolicitacoesPendentes({ onConcluido }) {
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [mostrarModalExcluir, setMostrarModalExcluir] = useState(false);
const [idParaExcluir, setIdParaExcluir] = useState(null);
const abrirModalExcluir = (id) => {
    setIdParaExcluir(id);
    setMostrarModalExcluir(true);
  };

  useEffect(() => {
    buscarSolicitacoes();
  }, []);

  const buscarSolicitacoes = async () => {
    const { data } = await axios.get("/api/public/api/agendamentos");
    const pendentes = data.filter((item) => !item.data || !item.hora);
    setSolicitacoes(pendentes);
  };

  const handleChange = (id, field, value) => {
    if (field === "data") {
      value = value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1/$2")
        .replace(/(\d{2}\/\d{2})(\d)/, "$1/$2")
        .slice(0, 10);
    } else if (field === "valor") {
      const onlyDigits = value.replace(/\D/g, "");
      const numberValue = (Number(onlyDigits) / 100).toFixed(2);
      value = `R$ ${numberValue.replace(".", ",")}`;
    }
  
    setSolicitacoes((prev) =>
      prev.map((s) =>
        s.id === id ? { ...s, [field]: value } : s
      )
    );
  };
  

  const concluirSolicitacao = async (id, data, hora) => {
    const solicitacao = solicitacoes.find((s) => s.id === id);
  
    try {
      let formattedData = null;
      if (data && data !== "00/00/0000") {
        const partes = data.split("/");
        if (partes.length === 3) {
          formattedData = `${partes[2]}-${partes[1]}-${partes[0]}`;
        }
      }
  
      await axios.put(`/api/public/api/agendamentos/${id}`, {
        nome: solicitacao.nome,
        telefone: solicitacao.telefone,
        rua: solicitacao.rua,
        numero: solicitacao.numero,
        bairro: solicitacao.bairro,
        complemento: solicitacao.complemento,
        cidade: solicitacao.cidade,
        data: formattedData,
        hora: hora || null,
        observacoes: solicitacao.observacoes || "",
        valor: solicitacao.valor
  ? parseFloat(solicitacao.valor.replace(/[R$\s.]/g, "").replace(",", ".")) // converte para número
  : null,

        concluido: 0, // ✅ Mantém como pendente de execução
      });
  
      buscarSolicitacoes();
      onConcluido();
    } catch (e) {
      console.error(e.response?.data || e.message);
      alert("Erro ao concluir solicitação");
    }
  };
  

  const confirmarExclusao = async () => {
    try {
      await axios.delete(`/api/public/api/agendamentos/${idParaExcluir}`);
      buscarSolicitacoes();
      onConcluido();
    } catch (e) {
      alert("Erro ao excluir solicitação");
    } finally {
      setMostrarModalExcluir(false);
      setIdParaExcluir(null);
    }
  };

  if (solicitacoes.length === 0) return null;

  return (
    <div className="max-w-4xl mx-auto mt-10 p-6 bg-yellow-50 border border-yellow-200 rounded-xl shadow-xl">
        {mostrarModalExcluir && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white rounded-xl shadow-xl max-w-sm w-full p-6 border-t-4 border-yellow-500">
      <h3 className="text-lg font-bold text-gray-800 mb-4">Excluir Solicitação</h3>
      <p className="text-sm text-gray-600 mb-6">
        Tem certeza que deseja excluir esta solicitação? Esta ação não poderá ser desfeita.
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setMostrarModalExcluir(false)}
          className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold"
        >
          Cancelar
        </button>
        <button
          onClick={confirmarExclusao}
          className="px-4 py-2 rounded bg-red-500 hover:bg-red-600 text-white font-semibold"
        >
          Excluir
        </button>
      </div>
    </div>
  </div>
)}

      <h2 className="text-2xl font-bold text-yellow-700 mb-4">📌 Solicitações Pendentes</h2>

      {solicitacoes.map((s) => (
        <div
          key={s.id}
          className="bg-white border rounded-lg shadow p-4 mb-4 flex flex-col md:flex-row items-center gap-4"
        >
          <div className="flex-1">
            <p className="font-semibold">{s.nome}</p>
            <p className="text-sm text-gray-500">{s.telefone}</p>
            <p className="text-sm text-gray-500">{s.rua}, {s.numero} - {s.bairro}</p>
          </div>

          <input
            type="text"
            placeholder="00/00/0000"
            value={s.data || ""}
            onChange={(e) => handleChange(s.id, "data", e.target.value)}
            className="border p-2 rounded w-28 text-center"
            maxLength={10}
          />

          <input
            type="time"
            value={(s.hora || "").slice(0, 5)}
            onChange={(e) => handleChange(s.id, "hora", e.target.value)}
            className="border p-2 rounded w-24 text-center"
          />  <textarea
          placeholder="Observações"
          value={s.observacoes || ""}
          onChange={(e) => handleChange(s.id, "observacoes", e.target.value)}
          className="border p-2 rounded w-full text-sm text-gray-700"
          rows={2}
        />
      
        <input
          type="text"
          placeholder="Valor (R$)"
          value={s.valor || ""}
          onChange={(e) => handleChange(s.id, "valor", e.target.value)}
          className="border p-2 rounded w-32 text-center"
        />
      
          

          <button
            onClick={() => concluirSolicitacao(s.id, s.data, s.hora)}
            className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded font-semibold"
          >
            Concluir
          </button>

          <button
            onClick={() => abrirModalExcluir(s.id)}
            className="text-red-600 hover:text-red-800 p-2"
            title="Excluir Solicitação"
          >
            <FaTrash />
          </button>
        </div>
      ))}
    </div>
  );
}
